export default __webpack_public_path__ + "static/media/5.5f0edb77.png";